import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Validators } from '@components/Form/FormItem/FormItemValidation';

import { Dictionaries } from '@/api/dictionaries/types';
import {
  ALL_SPECIES_LABEL,
  ANY_SEX_LABEL,
} from '@/pages/Administration/components/animalGroups/columns.config';
import { IndividualSexLabel } from '@/shared/vaccination/enums';
import { dictToOptions, enumToOptions } from '@/utils/utils';

// Значение пункта «Любой» в форме; на сервер уходит как sex = null
export const ANY_SEX = 'ANY';

export const transitionSchema = (dictionaries?: Dictionaries): IFormItem[] => [
  {
    label: 'Из группы',
    placeholder: 'Выберите группу',
    key: 'fromSpeciesId',
    type: 'select',
    payload: {
      options: dictToOptions(dictionaries?.ANIMAL_SPECIES),
    },
    validation: [Validators.required()],
  },
  {
    label: 'Пол',
    placeholder: 'Выберите пол',
    key: 'sex',
    type: 'select',
    default: ANY_SEX,
    payload: {
      allowClear: false,
      options: [
        { label: ANY_SEX_LABEL, value: ANY_SEX },
        ...enumToOptions(IndividualSexLabel),
      ],
    },
    validation: [Validators.required()],
  },
  {
    label: 'В группу',
    placeholder: 'Выберите группу',
    key: 'toSpeciesId',
    type: 'select',
    dependencies: ['fromSpeciesId'],
    payload: {
      options: dictToOptions(dictionaries?.ANIMAL_SPECIES),
    },
    validation: (form) => [
      Validators.required(),
      {
        validator: (_, value) =>
          value && value === form.getFieldValue('fromSpeciesId')
            ? Promise.reject(new Error('Группа животных не может переходить сама в себя'))
            : Promise.resolve(),
      },
    ],
  },
  {
    label: 'Возраст перехода (дней)',
    placeholder: 'Введите возраст',
    key: 'maxAgeDays',
    type: 'number',
    validation: [
      Validators.required(),
      { pattern: /^\d+$/, message: 'Введите целое неотрицательное число' },
    ],
  },
];

export const protocolTypeSchema = (dictionaries?: Dictionaries): IFormItem[] => [
  {
    label: 'Группа животных',
    placeholder: ALL_SPECIES_LABEL,
    key: 'animalSpeciesId',
    type: 'select',
    payload: {
      options: dictToOptions(dictionaries?.ANIMAL_SPECIES),
    },
  },
];
